import React from "react";
import { Text, Table, TableBody, TableCell, TableHeader, TableRow } from "@jsq/ds/core";
import * as styles from "../../styles_vanilla.css";
import { hasObjectsWithAmounts, formatMoney, pluralizeEntity, type MoneyType } from "../utils";
import type { GetFundAdminServicesQuery } from "#graphql/supergraphTypes";

type FundFamilyObjectsTableProps = {
  requestType: string;
  alsoHasEntityObjects: boolean;
  fundFamilyObjects: NonNullable<
    GetFundAdminServicesQuery["fundAdminServices"]
  >["edges"][number]["node"]["objects"];
};

const FundFamilyObjectsTable = ({
  requestType,
  alsoHasEntityObjects,
  fundFamilyObjects,
}: FundFamilyObjectsTableProps) => {
  const isEntitiesWithAmounts = hasObjectsWithAmounts(fundFamilyObjects);

  const getObjectDetailsAmount = (
    objectDetailsString: string | null | undefined,
  ): MoneyType => {
    const objectDetails = JSON.parse(objectDetailsString ?? "{}") as MoneyType;
    return objectDetails;
  };

  return (
    <div className={alsoHasEntityObjects ? styles.fundFamilyTableContainer : undefined}>
      <Table variant="muted" condensed>
        <TableHeader>
          <TableRow>
            <TableCell>Fund family</TableCell>
            {isEntitiesWithAmounts && (
              <TableCell className={styles.fundFamilyAmountHeaderCell} rightAligned>
                {requestType} amount
              </TableCell>
            )}
          </TableRow>
        </TableHeader>
        <TableBody>
          {fundFamilyObjects.map((fundFamily) => {
            if (fundFamily.objectValue.__typename !== "EntityCollectionObjectType") {
              return null;
            }

            const entities =
              fundFamily.objectValue.entities?.edges?.map(
                ({ node }: { node: { id: string; name: string } }) => node,
              ) ?? [];
            return (
              <TableRow alignment="top" key={fundFamily.objectValue.id}>
                <TableCell>
                  <Text>{fundFamily.objectValue.name}</Text>
                  <Text variant="secondary-sm" className={styles.relatedEntitiesDescription}>
                    Fund family with {entities.length} related{" "}
                    {pluralizeEntity(entities.length)}
                  </Text>
                  {entities.map((entity: { id: string; name: string }) => (
                    <Text key={entity.id} className={styles.entityName}>
                      {entity.name}
                    </Text>
                  ))}
                </TableCell>
                {isEntitiesWithAmounts && (
                  <TableCell rightAligned>
                    {formatMoney(getObjectDetailsAmount(fundFamily.objectDetails))}
                  </TableCell>
                )}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};

export default FundFamilyObjectsTable;
